@if (isHeaderVisible) {
  <app-page-header (retour)="onRetour()"
    [boutonRetourVisible]="hasRetour"
    [boutonRetourSansFondBlanc]="boutonRetourSansFondBlanc"
    [hasBackground]="hasBackground"
    [ngClass]="{'is-bandeau' : hasBackground, 'is-scroll': isPageScrolled}"
    [titre]="titre" [ngStyle]="{'width': pageWidth + 'px'}">
    <ng-content select="[headerRight]"></ng-content>
    @if (headerRight) {
      <ng-container *ngTemplateOutlet="headerRight"></ng-container>
    }
  </app-page-header>
}

<div #pageBaseContent class="page-base-content" [ngClass]="{'has-not-header': !isHeaderVisible}">
  @if (hasNavbarRightItems) {
    <div class="content-with-nav-right">
      <div class="content-left">
        <div class="page-content">
          <ng-container *ngTemplateOutlet="content"></ng-container>
        </div>
      </div>
      <div class="nav-right" [ngClass]="{'is-fixed': isPageScrolledNavRight}">
        <app-navbar-right [navbarRightItems]="navbarRightItems"></app-navbar-right>
      </div>
    </div>
  }

  @if (!hasNavbarRightItems) {
    <div class="page-content">
      <ng-container *ngTemplateOutlet="content"></ng-container>
    </div>
  }
</div>

<ng-template #content>
  <ng-content select="[pageContent]"></ng-content>
</ng-template>

